module.exports = __webpack_public_path__ + "media/images/favicon/mstile-310x310-a7cc551927fa3954d3e13582bb6ed819.png";